
import { FeatureFlagActionType } from 'redux/feature-flag/feature-flag.type';

let initialState = {
  isInitialized: false,
  flags: {},
}

export default (state = initialState, action: any) => {
  switch (action.type) {
    case FeatureFlagActionType.SET_FLAGS:
      return {
        ...state,
        flags: action.payload.flags,
        isInitialized: true,
      }
    default:
      return {
        ...state
      };
  }
}